module.exports = __webpack_public_path__ + "static/media/jp.e2d838a2.svg";